"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.chart_dollar = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var chart_dollar = function chart_dollar(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'chart-dollar-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    d: 'M10.4082 13.7251V13.043C12.0894 12.9033 13.04 12.0547 13.04 10.6851C13.04 9.5249 12.3633 8.81055 10.9829 8.51514L10.4082 8.39697V6.48486C10.9722 6.56543 11.375 6.96826 11.3911 7.45703H12.8896C12.8682 6.21631 11.9014 5.34082 10.4082 5.20117V4.4707H9.65625V5.20117C8.05566 5.33008 7.11035 6.17871 7.11035 7.5C7.11035 8.62256 7.80322 9.36377 9.09229 9.66455L9.65625 9.79883V11.7969C8.98486 11.7271 8.52832 11.3296 8.49072 10.7979H6.95459C6.95996 12.1084 7.9751 12.957 9.65625 13.0537V13.7251H10.4082ZM11.5146 10.8677C11.5146 11.4102 11.1064 11.7593 10.4082 11.8022V9.93311C11.1602 10.0728 11.5146 10.3735 11.5146 10.8677ZM8.66797 7.34961C8.66797 6.87158 9.07617 6.51172 9.65625 6.47949V8.24121C9.00635 8.1123 8.66797 7.80078 8.66797 7.34961Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M3.75 4C4.16421 4 4.5 4.33579 4.5 4.75L4.5 16.25C4.5 16.6642 4.16421 17 3.75 17C3.33579 17 3 16.6642 3 16.25L3 4.75C3 4.33579 3.33579 4 3.75 4Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M3 16.25C3 15.8358 3.33579 15.5 3.75 15.5H15.25C15.6642 15.5 16 15.8358 16 16.25C16 16.6642 15.6642 17 15.25 17H3.75C3.33579 17 3 16.6642 3 16.25Z',
    fill: '#4B5563'
  }));
};

exports.chart_dollar = chart_dollar;